import { css } from '@bts-web/utils-style-engine';
import { ReadOnlyTag } from '@bts-web/core-features/common';
import { MobileProfileMenu } from '../MobileProfileMenu/MobileProfileMenu';
import { NotificationsBell } from '../../../common/components/NotificationsBell/NotificationsBell';
import { AppLogoWithIslamicProp } from '../Reusable/AppLogo/AppLogoWithIslamicProp.use-client';

export const mobileHeaderWrapperStyles = css({
  backgroundColor: 'screen_background.primary',
  display: 'flex',
  justifyContent: 'space-between',
  py: 'extra_small',
  px: 'medium',
  alignItems: 'center',
});

const MobileHeader = (): React.ReactElement => {
  return (
    <header className={mobileHeaderWrapperStyles}>
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: 'medium',
        })}
      >
        <div
          className={css({
            display: 'flex',
            gap: 'extra_small_2',
            alignItems: 'center',
          })}
        >
          <AppLogoWithIslamicProp size={34} textLogoSize={160} />
        </div>

        <ReadOnlyTag />
      </div>

      <div
        className={css({
          display: 'flex',
          gap: 'extra_small_2',
          alignItems: 'center',
        })}
      >
        <MobileProfileMenu />

        <NotificationsBell />
      </div>
    </header>
  );
};

export { MobileHeader };
